import Vue from 'vue'
import App from 'app/web/page/app.vue'
import createStore from 'app/web/store/index.js'
import createRouter from 'app/web/router/index.js'

import mHeader from 'component/common/m-header'
import dowloadAppTips from 'component/common/dowload-app-tips.vue'
import icon from 'component/common/icon'
import globalMixin from 'mixins/global'
import _const from '../const/index'
import { Lazyload } from 'vant'
import { pic } from '@yxl/components'

let initDone = false
let runningEnv
function init() {
  Vue.component('m-header', mHeader)
  Vue.component('dowload-app-tips', dowloadAppTips)
  // eslint-disable-next-line vue/multi-word-component-names
  Vue.component('icon', icon)
  Vue.component('yxl-pic', pic)
  Vue.use(Lazyload)

  Vue.prototype.$const = _const
  const getRunningEnv = () => {
    const config = require('../../../yxlConfig.json')
    return {
      isDev: config.env !== '',
      env: config.env
    }
  }

  runningEnv = getRunningEnv()
  Vue.prototype.$runningEnv = runningEnv
  if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = function (err, vm, info) {
      // handle error
      // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
      // 只在 2.2.0+ 可用
      console.log(err, vm, info)
    }
  }
  Vue.mixin(globalMixin)

  Vue.prototype.isTextOpen = true

  initDone = true
}

if (!initDone) init()

export default function createApp(initState = {}) {
  const router = createRouter()
  const store = createStore({
    runningEnv: runningEnv,
    ...initState
  })
  // sync(store, router)

  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })

  return { app, router, store }
}
